import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
    table: {
        width: '100%',
        marginTop: 10,
        borderStyle: 'solid',
        borderWidth: 1,
        borderColor: '#000',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#000',
    },
    tableHeader: {
        backgroundColor: '#f0f0f0',
        fontWeight: 'bold',
    },
    tableCell: {
        flex: 1,
        padding: 5,
        borderRightWidth: 1,
        borderRightColor: '#000',
        fontSize: 10,
    },
    lastCell: {
        flex: 1,
        padding: 5,
        fontSize: 10,
    },
    summary: {
        marginTop: 10,
        fontSize: 10,
    },
});

const SmartBuildItemsTable = ({ items }) => {
    if (!items || items.length === 0) return null;

    // Filter items to only include Sheathing and Trim categories
    const filteredItems = items.filter(item =>
        item.Category === 'Sheathing' || item.Category === 'Trim'
    );

    if (filteredItems.length === 0) return null;

    const convertToFeetAndInches = (totalFeet) => {
        const feet = Math.floor(totalFeet);
        const totalInches = (totalFeet - feet) * 12;
        const quarterInches = Math.round(totalInches * 4) / 4; // Round to nearest 1/4 inch
        return `${feet}' ${quarterInches}"`;
    };

    // Calculate totals from filtered items
    const totalItems = filteredItems.reduce((sum, item) => sum + item.Qty, 0);
    const totalWeight = filteredItems.reduce((sum, item) => sum + (item.Weight || 0), 0);
    const totalPrice = filteredItems.reduce((sum, item) => sum + (item.Price || 0), 0);

    return (
        <View>
            <Text style={{ fontSize: 12, marginBottom: 5 }}>SmartBuild Items</Text>
            <View style={styles.table}>
                {/* Header Row */}
                <View style={[styles.tableRow, styles.tableHeader]}>
                    <Text style={styles.tableCell}>Full SKU</Text>
                    <Text style={styles.tableCell}>Material</Text>
                    <Text style={styles.tableCell}>Quantity</Text>
                    <Text style={styles.tableCell}>Length</Text>
                    <Text style={styles.tableCell}>Category</Text>
                </View>

                {/* Data Rows */}
                {filteredItems.map((item, index) => (
                    <View key={`${item.FullSku}-${index}`} style={styles.tableRow}>
                        <Text style={styles.tableCell}>{item.FullSku}</Text>
                        <Text style={styles.tableCell}>{item.Material}</Text>
                        <Text style={styles.tableCell}>{item.Qty}</Text>
                        <Text style={styles.tableCell}>{convertToFeetAndInches(item.Length)}</Text>
                        <Text style={styles.lastCell}>{item.Category}</Text>
                    </View>
                ))}
            </View>

            {/* Summary */}
            <View style={styles.summary}>
                {totalPrice > 0 && (
                    <Text>Total Price: ${totalPrice.toFixed(2)}</Text>
                )}
            </View>
        </View>
    );
};

export default SmartBuildItemsTable; 